import A from './components/A.react';
import Abbr from './components/Abbr.react';
import Acronym from './components/Acronym.react';
import Address from './components/Address.react';
import Area from './components/Area.react';
import Article from './components/Article.react';
import Aside from './components/Aside.react';
import Audio from './components/Audio.react';
import B from './components/B.react';
import Base from './components/Base.react';
import Basefont from './components/Basefont.react';
import Bdi from './components/Bdi.react';
import Bdo from './components/Bdo.react';
import Big from './components/Big.react';
import Blink from './components/Blink.react';
import Blockquote from './components/Blockquote.react';
import Br from './components/Br.react';
import Button from './components/Button.react';
import Canvas from './components/Canvas.react';
import Caption from './components/Caption.react';
import Center from './components/Center.react';
import Cite from './components/Cite.react';
import Code from './components/Code.react';
import Col from './components/Col.react';
import Colgroup from './components/Colgroup.react';
import Command from './components/Command.react';
import Content from './components/Content.react';
import Data from './components/Data.react';
import Datalist from './components/Datalist.react';
import Dd from './components/Dd.react';
import Del from './components/Del.react';
import Details from './components/Details.react';
import Dfn from './components/Dfn.react';
import Dialog from './components/Dialog.react';
import Div from './components/Div.react';
import Dl from './components/Dl.react';
import Dt from './components/Dt.react';
import Element from './components/Element.react';
import Em from './components/Em.react';
import Embed from './components/Embed.react';
import Fieldset from './components/Fieldset.react';
import Figcaption from './components/Figcaption.react';
import Figure from './components/Figure.react';
import Font from './components/Font.react';
import Footer from './components/Footer.react';
import Form from './components/Form.react';
import Frame from './components/Frame.react';
import Frameset from './components/Frameset.react';
import H1 from './components/H1.react';
import H2 from './components/H2.react';
import H3 from './components/H3.react';
import H4 from './components/H4.react';
import H5 from './components/H5.react';
import H6 from './components/H6.react';
import Header from './components/Header.react';
import Hgroup from './components/Hgroup.react';
import Hr from './components/Hr.react';
import I from './components/I.react';
import Iframe from './components/Iframe.react';
import Img from './components/Img.react';
import Ins from './components/Ins.react';
import Isindex from './components/Isindex.react';
import Kbd from './components/Kbd.react';
import Keygen from './components/Keygen.react';
import Label from './components/Label.react';
import Legend from './components/Legend.react';
import Li from './components/Li.react';
import Link from './components/Link.react';
import Listing from './components/Listing.react';
import Main from './components/Main.react';
import MapEl from './components/MapEl.react';
import Mark from './components/Mark.react';
import Marquee from './components/Marquee.react';
import Meta from './components/Meta.react';
import Meter from './components/Meter.react';
import Multicol from './components/Multicol.react';
import Nav from './components/Nav.react';
import Nextid from './components/Nextid.react';
import Nobr from './components/Nobr.react';
import Noscript from './components/Noscript.react';
import ObjectEl from './components/ObjectEl.react';
import Ol from './components/Ol.react';
import Optgroup from './components/Optgroup.react';
import Option from './components/Option.react';
import Output from './components/Output.react';
import P from './components/P.react';
import Param from './components/Param.react';
import Picture from './components/Picture.react';
import Plaintext from './components/Plaintext.react';
import Pre from './components/Pre.react';
import Progress from './components/Progress.react';
import Q from './components/Q.react';
import Rb from './components/Rb.react';
import Rp from './components/Rp.react';
import Rt from './components/Rt.react';
import Rtc from './components/Rtc.react';
import Ruby from './components/Ruby.react';
import S from './components/S.react';
import Samp from './components/Samp.react';
import Script from './components/Script.react';
import Section from './components/Section.react';
import Select from './components/Select.react';
import Shadow from './components/Shadow.react';
import Slot from './components/Slot.react';
import Small from './components/Small.react';
import Source from './components/Source.react';
import Spacer from './components/Spacer.react';
import Span from './components/Span.react';
import Strike from './components/Strike.react';
import Strong from './components/Strong.react';
import Sub from './components/Sub.react';
import Summary from './components/Summary.react';
import Sup from './components/Sup.react';
import Table from './components/Table.react';
import Tbody from './components/Tbody.react';
import Td from './components/Td.react';
import Template from './components/Template.react';
import Textarea from './components/Textarea.react';
import Tfoot from './components/Tfoot.react';
import Th from './components/Th.react';
import Thead from './components/Thead.react';
import Time from './components/Time.react';
import Title from './components/Title.react';
import Tr from './components/Tr.react';
import Track from './components/Track.react';
import U from './components/U.react';
import Ul from './components/Ul.react';
import Var from './components/Var.react';
import Video from './components/Video.react';
import Wbr from './components/Wbr.react';
import Xmp from './components/Xmp.react';

export {
    A,
    Abbr,
    Acronym,
    Address,
    Area,
    Article,
    Aside,
    Audio,
    B,
    Base,
    Basefont,
    Bdi,
    Bdo,
    Big,
    Blink,
    Blockquote,
    Br,
    Button,
    Canvas,
    Caption,
    Center,
    Cite,
    Code,
    Col,
    Colgroup,
    Command,
    Content,
    Data,
    Datalist,
    Dd,
    Del,
    Details,
    Dfn,
    Dialog,
    Div,
    Dl,
    Dt,
    Element,
    Em,
    Embed,
    Fieldset,
    Figcaption,
    Figure,
    Font,
    Footer,
    Form,
    Frame,
    Frameset,
    H1,
    H2,
    H3,
    H4,
    H5,
    H6,
    Header,
    Hgroup,
    Hr,
    I,
    Iframe,
    Img,
    Ins,
    Isindex,
    Kbd,
    Keygen,
    Label,
    Legend,
    Li,
    Link,
    Listing,
    Main,
    MapEl,
    Mark,
    Marquee,
    Meta,
    Meter,
    Multicol,
    Nav,
    Nextid,
    Nobr,
    Noscript,
    ObjectEl,
    Ol,
    Optgroup,
    Option,
    Output,
    P,
    Param,
    Picture,
    Plaintext,
    Pre,
    Progress,
    Q,
    Rb,
    Rp,
    Rt,
    Rtc,
    Ruby,
    S,
    Samp,
    Script,
    Section,
    Select,
    Shadow,
    Slot,
    Small,
    Source,
    Spacer,
    Span,
    Strike,
    Strong,
    Sub,
    Summary,
    Sup,
    Table,
    Tbody,
    Td,
    Template,
    Textarea,
    Tfoot,
    Th,
    Thead,
    Time,
    Title,
    Tr,
    Track,
    U,
    Ul,
    Var,
    Video,
    Wbr,
    Xmp
};
